import { Form } from 'formik';
import React from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import Input from 'components/input';
import { useTranslation } from 'react-i18next';

const WhAlreadyDomain = ({ formikProp, setParentFieldValue }) => {
  const { t } = useTranslation();
  const { values, setFieldValue, errors, touched, handleBlur } = formikProp;
  return (
    <Form>
      <Styles.NoNeedDomain>
        <Styles.TransferDomainSc>
          <Input
            placeholder={t('wh/create.step1_string3')}
            value={values['transfer_domain']}
            onBlur={handleBlur}
            onChange={(e) => {
              setFieldValue('transfer_domain', e.target.value);
              setParentFieldValue(e.target.value);
            }}
            error={errors['transfer_domain']}
            touched={touched['transfer_domain']}
            styling={{ marginTop: '-1em', width: '100%', marginRight: '1em' }}
            name="transfer_domain"
            inputProps={{ maxLength: 64 }}
          />
        </Styles.TransferDomainSc>
      </Styles.NoNeedDomain>
    </Form>
  );
};

export default WhAlreadyDomain;
